import { BaseModel } from "./base"
import { JsonProperty } from "../requests/jsonparser";
import { Category } from "./category"
import { Album } from "./album";

export class Podcast extends BaseModel {

    @JsonProperty({ type: 'false' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'Podcast' })
    MODELNAME: string;

    @JsonProperty({ type: 'string' })
    id: string;

    @JsonProperty({ type: 'number' })
    order: number;

    @JsonProperty({ type: 'string' })
    title: string;

    @JsonProperty({ type: 'string?' })
    subtitle?: string;

    @JsonProperty({ type: 'string' })
    slug: string;

    @JsonProperty({ type: 'string' })
    curator: string;

    @JsonProperty({ type: 'boolean' })
    featured: boolean;

    @JsonProperty({ type: 'string?' })
    description?: string;

    @JsonProperty({ type: 'string' })
    image_url: string;

    @JsonProperty({ type: 'string' })
    image_thumbnail_url: string;

    @JsonProperty({ clazz: Category, type: 'Category' })
    category: Category

    @JsonProperty({ clazz: Album, type: 'Album?' })
    albums?: Album[]
}



// WEBPACK FOOTER //
// ./src/api/src/models/podcast.ts